import { render, staticRenderFns } from "./ManagerSidebar.vue?vue&type=template&id=0fd0b554&scoped=true"
import script from "./ManagerSidebar.vue?vue&type=script&lang=js"
export * from "./ManagerSidebar.vue?vue&type=script&lang=js"
import style0 from "./ManagerSidebar.vue?vue&type=style&index=0&id=0fd0b554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0b554",
  null
  
)

export default component.exports